
export interface ModelVariable {
  standard_name: string;
  unit: string;
  description: string;
}
// Custom edge component for variable flow
export const VariableEdge = ({ id, sourceX, sourceY, targetX, targetY, data }: any) => {
  // Create a smooth curve between nodes
  const midX = (sourceX + targetX) / 2;
  const midY = (sourceY + targetY) / 2;
  
  const edgePath = `M${sourceX},${sourceY} C${sourceX + 50},${sourceY} ${targetX - 50},${targetY} ${targetX},${targetY}`;

  return (
    <>
      <path
        id={id}
        style={{
          stroke: '#1e9cd7',
          strokeWidth: 2,
          fill: 'none',
          markerEnd: 'url(#arrowhead)'
        }}
        className="react-flow__edge-path"
        d={edgePath}
      />
      
      {/* Variables label */}
      {data?.vars && data.vars.length > 0 && (
        <foreignObject
          x={midX - 80}
          y={midY - 20}
          width="160"
          height="40"
          style={{ overflow: 'visible' }}
        >
          <div style={{
            fontSize: '9px',
            textAlign: 'center',
            minWidth: 'max-content',
            padding: '4px 6px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            border: '1px solid #e5e7eb',
            borderRadius: '6px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
          }}>            <div style={{ 
              display: 'flex', 
              flexDirection: 'column',
              gap: '1px', 
              alignItems: 'center',
              fontSize: '8px'
            }}>
              {data.vars.map((variable: ModelVariable, index: number) => (
                <div 
                  key={index} 
                  style={{ 
                    padding: '1px 3px',
                    backgroundColor: '#f3f4f6',
                    border: '1px solid #d1d5db',
                    borderRadius: '3px',
                    fontSize: '7px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {variable.standard_name}
                </div>
              ))}
            </div>
          </div>
        </foreignObject>
      )}
    </>
  );
};